import { createSelector } from '@reduxjs/toolkit';
import { BatchDefinitionState } from 'ducks/batch-definition/slices';
import { RootState } from 'store';

const batchDefinitionSlice = (state: RootState) => state.batch_definition;

export const selectBatchDefinition = createSelector([batchDefinitionSlice], (state): BatchDefinitionState => state);
